<div class="pre-login">
    <div class="pre-login-col-1 h-100">
        <left-panel-onboarding></left-panel-onboarding>
    </div>
    <div class="pre-login-col-2">
    </div>
    <div class="pre-login-col-3">
        <div class="onboarding-canvas">
            <div class="font-400 font-size-20px line-h-25 mt-ipad-15">
                {{ "PushNotifications" | translate }}
            </div>
            <div class="border-bottom border-top border-color-ddd bg-base-100 p-24 mt-40">
                <grid-row class="align-item-center col-space">
                    <grid-col col="auto">
                        <div class="font-600 font-size-16px color-base-2200 line-h-25 letter-spacing-2">
                            {{ "DealsRewards" | translate }}
                        </div>
                        <div class="font-400 font-size-14px color-base-700 line-h-22 letter-spacing-1 mt-5">
                            {{ "NewOffersedemptions" | translate }}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="form-group">
                            <div class="custom-toggle">
                                <input type="checkbox" id="toggle1" class="not-on-this">
                                <label for="toggle1" class="not-on-this">
                                    <span class="yes"> {{ "Yes" | translate }} </span>
                                    <span class="no"> {{ "No" | translate }} </span>
                                </label>
                            </div>
                        </div>
                    </grid-col>
                </grid-row>
            </div>
            <grid-row class="justify-content-between mt-50">
                <grid-col col="auto">
                    <button class="btn-back" (click)="back()">
                        <i class="icon-back"></i>
                    </button>
                </grid-col>
                <grid-col col="9" mobile="auto">
                    <button class="btn-dft">
                        {{ "SaveChanges" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>
